import { apiClient } from '../../../../helpers/api_helper';

export const getAllCityData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/City/GetAllCity`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getCityById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/City/GetCityDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getCityListByStateId = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/City/GetCitySelectListByStateId?stateId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const DeleteCustomerAddress = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Customer/DeleteCustomerAddress?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const createCity = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/City/InsertCity', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateCity = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/City/UpdateCity', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteCity = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/City/DeleteCity?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};